import { FC, PropsWithChildren, CSSProperties, MouseEventHandler } from 'react';

import { IonCardContent } from '@ionic/react';

import styles from './CardFooter.module.scss';

type CardFooterProps = PropsWithChildren<{
  className?: string;
  justifyContent?: CSSProperties['justifyContent'];
}>;

export const CardFooter: FC<CardFooterProps> = ({
  children,
  justifyContent = 'flex-end',
}) => {
  const handleOnClick: MouseEventHandler<HTMLIonCardContentElement> = (e) =>
    e.stopPropagation();

  return (
    <IonCardContent
      onClick={handleOnClick}
      className={styles.root}
      style={{ justifyContent }}
    >
      {children}
    </IonCardContent>
  );
};
